/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createWeakMixingAngle } from '../../factoriesAny.js';
export var weakMixingAngleDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createWeakMixingAngle: createWeakMixingAngle
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesWeakMixingAngle.generated.js
// module id = 1683
// module chunks = 0